import type { DcrLicenseInput } from '@/core/graphql/generated/types';

import type { usePicklistValues } from '../../_hooks/usePicklistValues';
import type { mapHcpToFormDefaultsIn } from '../mapHcpToFormDefaultsIn';

import { getNetworkFieldValue } from './getNetworkFieldValue';

type FormDefaults = ReturnType<typeof mapHcpToFormDefaultsIn>;
type LicenseItem = NonNullable<FormDefaults['licenses']>[number];

type Picklists = ReturnType<typeof usePicklistValues>['picklists'];

type Props = {
	licenses: Partial<LicenseItem>[];
	licenseStatusOptions: Picklists['licenseStatusOptions'];
	unavailableFields: string[] | undefined;
};

export const mapLicensesToNetworkApi = ({
	licenses,
	licenseStatusOptions,
	unavailableFields
}: Props): DcrLicenseInput[] | undefined => {
	if (!licenses || licenses.length === 0) {
		return undefined;
	}

	return licenses?.map(license => {
		const status = license?.licenseStatus_V;
		const resolvedStatus = licenseStatusOptions?.find(
			s => s.name === status || s.id === status
		);

		const isNew = !license.vid_V;

		const mapped: DcrLicenseInput = {
			expirationDate_V: getNetworkFieldValue(license.expirationDate_V, {
				isNew
			}),
			licenseNumber_V: getNetworkFieldValue(license.licenseNumber_V, {
				isNew
			}),
			typeValue_V: getNetworkFieldValue(license.typeValue_VId, { isNew }), // TODO: DCR check why this doesn propagate - https://dev.opendatalive.com/hcp/-939632969428830952
			vid_V: license.vid_V ? license.vid_V : undefined,
			licenseStatus_VId:
				getNetworkFieldValue(resolvedStatus?.id, { isNew }) ?? undefined
		};

		if (unavailableFields && unavailableFields.length > 0) {
			(Object.keys(mapped) as (keyof DcrLicenseInput)[]).forEach(key => {
				if (unavailableFields.includes(key)) {
					delete mapped[key];
				}
			});
		}

		return mapped;
	});
};
